module.exports = __webpack_public_path__ + "img/et.211c5f98.svg";